<template>
  <div>
    <list
      ref="refJobLinePositionList"
      sort-by="PuestoLineaAscensoId"
      :refetch-records="fetchJobLinePositions"
      refetch-records-name="puestosLineasAscenso"
      :actions="actions"
      key-field="puestoLineaAscensoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteJobLinePosition"
      :filters.sync="filters"
    >
      <template #cell(delArea)="data">
        <b-badge
          pill
          :variant="`light-${data.item.delArea?'success':'danger'}`"
          class="text-capitalize w-50"
        >
          {{ data.item.delArea ? $t('humanResources.profileSalary.columns.haveYes') : $t('humanResources.profileSalary.columns.haveNo') }}
        </b-badge>
      </template>
    </list>
  </div>
</template>
<script>

import { BBadge } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
    BBadge,
  },
  setup() {
    /* Refs */
    const refJobLinePositionList = ref(null)
    /* Services */
    const {
      fetchJobLinePositions,
      deleteJobLinePosition,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.jobLinePosition.columns.job'),
        key: 'puesto.nombre',
      },
      {
        label: i18n.t('humanResources.jobLinePosition.columns.fromArea'),
        key: 'delArea',
      },
      {
        label: i18n.t('humanResources.jobLinePosition.columns.order'),
        key: 'orden',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'PuestoHorario',
        routeName: 'apps-human-resources-job-line-position-edit',
        params: ['puestoLineaAscensoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'PuestoHorario',
        params: ['puestoLineaAscensoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-job-line-position-add',
        label: i18n.t('Routes.JobLinePositionAdd'),
        aclAction: 'create',
        aclResource: 'PuestoHorario',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refJobLinePositionList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchJobLinePositions,
      deleteJobLinePosition,
    }
  },
}
</script>
